var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Welcome",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.223,
    height: 36.223,
    viewBox: "0 0 36.223 36.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9956",
    "data-name": "Path 9956",
    d: "M0,0H36.223V36.223H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9957",
    "data-name": "Path 9957",
    d: "M20.6,10.037V7.019A3.019,3.019,0,0,0,17.583,4H7.019A3.019,3.019,0,0,0,4,7.019V25.13a3.019,3.019,0,0,0,3.019,3.019H17.583A3.019,3.019,0,0,0,20.6,25.13V22.111",
    transform: "translate(2.037 2.037)",
    fill: "none",
    stroke: "#969498",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9958",
    "data-name": "Path 9958",
    d: "M27.621,13.528H8L12.528,9",
    transform: "translate(4.074 4.583)",
    fill: "none",
    stroke: "#969498",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9959",
    "data-name": "Path 9959",
    d: "M12.528,16.528,8,12",
    transform: "translate(4.074 6.111)",
    fill: "none",
    stroke: "#969498",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/Welcome.cbfb97f913e8d6cd12f43052bb0b28e6.svg";
export { ForwardRef as ReactComponent };